import React from 'react';

import { useIntl } from 'react-intl';

import { queryClient } from 'src/lib/react-query';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { toast } from 'src/hooks/useToast';
import { ServicePlanCategory } from 'src/features/servicePlanCategory/utils/types';
import {
    LIST_SERVICE_PLAN_CATEGORIES_RESOURCE
} from 'src/features/servicePlanCategory/api/useListServicePlanCategories';
import { useCreateServicePlanCategory } from 'src/features/servicePlanCategory/api/useCreateServicePlanCategory';
import { servicePlanCategoriesMessages } from 'src/features/servicePlanCategory/utils/messages';
import ServicePlanCategoryFormModal
    from 'src/features/servicePlanCategory/components/forms/ServicePlanCategoryFormModal';

interface CreateServicePlanCategoryFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    selectedServicePlanCategory?: ServicePlanCategory;
    children?: React.ReactNode;
}

function CreateServicePlanCategoryFormModal<TData>({ className, semantics }: CreateServicePlanCategoryFormModalProps<TData>) {
    const { formatMessage } = useIntl();

    const { mutate, isPending } = useCreateServicePlanCategory({
        onSuccess: (success) => {
            void queryClient.invalidateQueries({ queryKey: [LIST_SERVICE_PLAN_CATEGORIES_RESOURCE] });
            toast({
                title: formatMessage(servicePlanCategoriesMessages.createServicePlanCategorySuccess),
                description: formatMessage(servicePlanCategoriesMessages.createServicePlanCategorySuccessDescription, {
                    entry: success.name,
                }),
            });
        },
    });

    return (
        <ServicePlanCategoryFormModal
            className={className}
            mutate={(values, onSuccess, onError) => mutate(values, { onSuccess, onError })}
            title={formatMessage(generalMessages.createEntry, { entry: semantics?.entryName?.toLowerCase() })}
            icon={ICON_MAP.ADD}
            isPending={isPending}
            subtitle={formatMessage(servicePlanCategoriesMessages.addServicePlanCategorySubtitle)}
        />
    );
}

export default CreateServicePlanCategoryFormModal;
